export enum OutgoingStatisticsParameters {
  From = 'From',
  To = 'To',
  ClinicIds = 'ClinicIds',
  Types = 'Types',
  FormBatchIds = 'FormBatchIds',
  DispensarizationBatchIds = 'DispensarizationBatchIds',
  FormTemplateIds = 'FormTemplateIds',
}
